import './news-categories-edit-modal.tag'
riot.tag2('news-categories-list', '  <catalog object="NewsCategory" cols="{cols}" remove="{remove}" dblclick="{addEdit}" add="{addEdit}" reload="true" store="news-categories-list">\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="title">{row.title}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function(opts) {
'use strict';

var self = this;

self.mixin('remove');
self.collection = 'NewsCategory';

self.cols = [{ name: 'id', value: '#' }, { name: 'title', value: 'Наименование' }];

self.addEdit = function (e) {
    var id = void 0;
    if (e.item && e.item.row) {
        id = e.item.row.id;
    }

    modals.create('news-categories-edit-modal', {
        type: 'modal-primary',
        id: id,
        submit: function submit() {
            var _this = this;
            var params = _this.item;
            _this.error = _this.validation.validate(_this.item, _this.rules);

            if (!_this.error) {
                API.request({
                    object: 'NewsCategory',
                    method: 'Save',
                    data: params,
                    success: function success(response) {
                        popups.create({ title: 'Успех!', text: 'Категория сохранена!', style: 'popup-success' });
                        observable.trigger('news-categories-reload');
                        _this.modalHide();
                    }
                });
            }
        }
    });
};

observable.on('news-categories-reload', function () {
    self.tags.catalog.reload();
});
});


// WEBPACK FOOTER //
// ./pages/news/news-categories-list.tag